// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Button, Stack } from '@shopify/polaris';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';

type Props = {
  checked: boolean
};

type ComposedProps = Props & WithI18nProps;

class SubLayout14 extends Component<ComposedProps> {
  render() {
    const { i18n, checked } = this.props;
    const SubLayoutClass = classnames('sub-layout-item', {
      active: checked
    });
    return (
      <div className={SubLayoutClass}>
        <div className="sub-layout-item__image">
          <img src={getAssetURL(ADMIN_APP_ASSET_PATHS?.themeSetting?.sample)} alt="sample" />
        </div>
        <div className="sub-layout-item__info">
          <p className="product-name">Small Naomi</p>
          <p className="product-vendor">PULL& PEAR</p>
          <p className="product-price">$485.00 CAD</p>
        </div>
        <div className="sub-layout-item__action">
          <Stack distribution="leading">
            <Button>{i18n.translate('AdminHTML.ThemeSetting.LayoutModal.subLayout_Button')}</Button>
          </Stack>
        </div>
      </div>
    );
  }
}

export default withI18n()(SubLayout14);
